import { ADMIN_ROUTES } from "@/lib/routes";

export interface ModuleRoutes {
  admin: string;
  member: string | null;
}

export const MODULE_ROUTES: Record<string, ModuleRoutes> = {
  EVENTS: { admin: ADMIN_ROUTES.events, member: "/events" },
  // The old-layout /browse page is gone; the feed is the member posts view.
  POSTS: { admin: ADMIN_ROUTES.posts, member: "/" },
  COACHES: { admin: ADMIN_ROUTES.coaches, member: "/coaches" },
  MEMBERS: { admin: ADMIN_ROUTES.members, member: "/members" },
  SUBSCRIPTIONS: { admin: ADMIN_ROUTES.plans, member: null },
  RESOURCES: { admin: "/resources", member: "/resources" },
  PAGES: { admin: ADMIN_ROUTES.pages, member: "/pages" },
  THREADS: { admin: ADMIN_ROUTES.threads, member: "/threads" },
  TRACK_FEEDBACK: { admin: ADMIN_ROUTES.feedback, member: "/track-feedback" },
  COLLECTIONS: { admin: ADMIN_ROUTES.collections, member: "/collections" },
  LIVE_STREAM: { admin: ADMIN_ROUTES.events, member: "/events" },
  DISCORD_INTEGRATION: {
    admin: ADMIN_ROUTES.settingsIntegrations,
    member: null,
  },
  LANDING_PAGE: { admin: ADMIN_ROUTES.landingPage, member: null },
  ONBOARDING: { admin: ADMIN_ROUTES.onboarding, member: null },
  COURSES: { admin: ADMIN_ROUTES.courses, member: "/courses" },
  SAMPLE_PACKS: { admin: ADMIN_ROUTES.samplePacks, member: "/sample-packs" },
};

/**
 * Convert a module KEY into a human-readable label as a fallback when no
 * ModuleDefinition name is available (e.g. "COLLECTIONS" → "Collections",
 * "TRACK_FEEDBACK" → "Track Feedback"). Prevents raw upper-case keys leaking
 * into the nav.
 */
export function humanizeModuleKey(key: string): string {
  return key
    .toLowerCase()
    .split(/[_\s]+/)
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

/** Keys treated as main navigation items, excluded from configurable module list */
export const MAIN_KEYS = new Set(["POSTS", "SETTINGS", "SHARE", "DASHBOARD"]);

/** Module keys excluded from navigation display (settings-only modules stay in /admin/customise) */
export const EXCLUDED_MODULE_KEYS = new Set([
  "VIDEO_EMBEDS",
  "VIDEO_UPLOADS",
  "DISCORD_INTEGRATION",
  "LANDING_PAGE",
  "ONBOARDING",
  "SUBSCRIPTIONS",
  // Retired from navigation. /threads still resolves for existing links, but
  // the module no longer earns a nav slot in any studio.
  "THREADS",
]);

/**
 * Grandfathered modules — only shown/installable for studios that ALREADY have
 * them installed (non-OFF state). New studios cannot discover or install these.
 */
export const INSTALL_RESTRICTED_MODULE_KEYS = new Set(["THREADS"]);
